import { render, staticRenderFns } from "./InitialPopUp.vue?vue&type=template&id=12b5b954&scoped=true&"
import script from "./InitialPopUp.vue?vue&type=script&lang=js&"
export * from "./InitialPopUp.vue?vue&type=script&lang=js&"
import style0 from "./InitialPopUp.vue?vue&type=style&index=0&id=12b5b954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b5b954",
  null
  
)

export default component.exports